import React from 'react';
import { Navigate, Outlet } from 'react-router';

import { storageKeys } from '../../../app/config';
import { rootRoutes } from '../../../app/routers/rootRoutes';
import { Layout } from '../Layout';

export const PrivateRoute = () => {
  const isAuthenticated = !!localStorage.getItem(storageKeys.token);

  if (!isAuthenticated) {
    return <Navigate to={rootRoutes.login} />;
  }

  return (
    <>
      <Layout>
        <Outlet />
      </Layout>
    </>
  );
};
